import httpClient from '../httpClient';

const websocketPath = (routePath: TemplateStringsArray) =>
  `websockets/${routePath}`;

function getToken() {
  return httpClient.get<{ token: string }>(websocketPath`token-shareable-link`);
}

export default {
  getToken,
};
